<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form @submit.prevent="update">
                <div class="modal-header">
                    <button type="button" class="close" @click="goBack()">×</button>
                    <h4 class="modal-title">{{ $t('lead') }}</h4>
                </div>
                <div class="modal-body">
                    <div class="modal_deal">
                        <div class="row">
                            <div class="col-sm-12 col-md-3 t_center m_md_bottom_15">
                                <img class="img-circle m_0_auto max_130" :src="record.avatar || `/static/images/avatar.jpg`">
                            </div>
                            <div class="col-sm-12 col-md-9">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['first_name']}">
                                        <label>{{ $t('first_name') }}</label>
                                        <input type="text" class="form-control" v-model="record.first_name">
                                        <span class="error" v-if="errors['first_name']">{{ errors['first_name'][0] }}</span>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['last_name']}">
                                        <label>{{ $t('last_name') }}</label>
                                        <input type="text" class="form-control" v-model="record.last_name">
                                        <span class="error" v-if="errors['last_name']">{{ errors['last_name'][0] }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 m_bottom_15" :class="{'has-error': errors['reference']}">
                                        <label>{{ $t('reference') }}</label>
                                        <input type="text" class="form-control" v-model="record.reference">
                                        <span class="error" v-if="errors['reference']">{{ errors['reference'][0] }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-3 m_bottom_15" :class="{'has-error': errors['country_id']}">
                                <label>{{ $t('country') }}</label>
                                <pml-select-countries v-model="record.country_id" :value="record.country_id"></pml-select-countries>
                                <span class="error" v-if="errors['country_id']">{{ errors['country_id'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-sm-5 m_bottom_15" :class="{'has-error': errors['gender']}">
                                <label>{{ $t('gender') }}</label>
                                <pml-select v-model="record.gender" :options="genders"></pml-select>
                                <span class="error" v-if="errors['gender']">{{ errors['gender'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-sm-4 m_bottom_15" :class="{'has-error': errors['dob']}">
                                <label>{{ $t('date_of_birth') }}</label>
                                <pml-date-picker v-model="record.dob" view-mode="years"></pml-date-picker>
                                <span class="error" v-if="errors['dob']">{{ errors['dob'][0] }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-sm-4 m_bottom_15" :class="{'has-error': errors['email']}">
                                <label class="input-group">
                                    <span class="input-group-addon" v-pml-tooltip="$t('email')"><i class="fa-fw fa fa-envelope"></i></span>
                                    <input type="email" class="form-control" :placeholder="$t('email')" v-model="record.email">
                                </label>
                                <span class="error" v-if="errors['email']">{{ errors['email'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4 m_bottom_15" :class="{'has-error': errors['phone']}">
                                <label class="input-group">
                                    <span class="input-group-addon" v-pml-tooltip="$t('phone')"><i class="fa-fw fa fa-phone"></i></span>
                                    <input type="text" class="form-control" :placeholder="$t('phone')" v-model="record.phone">
                                </label>
                                <span class="error" v-if="errors['phone']">{{ errors['phone'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-sm-6 col-md-4 m_bottom_15" :class="{'has-error': errors['mobile']}">
                                <label class="input-group">
                                    <span class="input-group-addon" v-pml-tooltip="$t('mobile')"><i class="fa-fw fa fa-mobile"></i></span>
                                    <input type="text" class="form-control" :placeholder="$t('mobile')" v-model="record.mobile">
                                </label>
                                <span class="error" v-if="errors['mobile']">{{ errors['mobile'][0] }}</span>
                            </div>
                        </div>
                        <div class="row">

                            <div class="col-xs-12" :class="{'has-error': errors['comments']}">
                                <label>{{ $t('comments') }} <small class="text-muted">({{ $t('lead') }})</small></label>
                                <textarea class="form-control autogrow" v-model="record.comments" v-pml-autosize></textarea>
                                <span class="error" v-if="errors['comments']">{{ errors['comments'][0] }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal_deal">
                        <h5 class="m-t-0"><i class="fa fa-home"></i> {{ $t('address') }}</h5>
                        <div class="row">
                            <div class="col-xs-12 col-sm-7 col-md-8 m_bottom_15" :class="{'has-error': errors['address']}">
                                <label>{{ $t('address') }}</label>
                                <input type="text" class="form-control" v-model="record.address">
                                <span class="error" v-if="errors['address']">{{ errors['address'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-sm-5 col-md-4 m_bottom_15" :class="{'has-error': errors['zip_code']}">
                                <label>{{ $t('zip_code') }}</label>
                                <input type="text" class="form-control" v-model="record.zip_code">
                                <span class="error" v-if="errors['zip_code']">{{ errors['zip_code'][0] }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['complement']}">
                                <label>{{ $t('complement') }}</label>
                                <input type="text" class="form-control" v-model="record.complement">
                                <span class="error" v-if="errors['complement']">{{ errors['complement'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['district']}">
                                <label>{{ $t('district') }}</label>
                                <input type="text" class="form-control" v-model="record.district">
                                <span class="error" v-if="errors['district']">{{ errors['district'][0] }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 m_md_bottom_15" :class="{'has-error': errors['city']}">
                                <label>{{ $t('city') }}</label>
                                <input type="text" class="form-control" v-model="record.city">
                                <span class="error" v-if="errors['city']">{{ errors['city'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-sm-6" :class="{'has-error': errors['state']}">
                                <label>{{ $t('state') }}</label>
                                <input type="text" class="form-control" v-model="record.state">
                                <span class="error" v-if="errors['state']">{{ errors['state'][0] }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal_deal">
                        <h5 class="m-t-0"><i class="fa fa-link"></i> {{ $t('social_media') }}</h5>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['site']}">
                                <label class="input-group">
                                    <span class="input-group-addon" v-pml-tooltip="$t('website')"><i class="fa-fw fa fa-desktop"></i></span>
                                    <input type="text" class="form-control" :placeholder="$t('website')" v-model="record.site">
                                </label>
                                <span class="error" v-if="errors['site']">{{ errors['site'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['skype']}">
                                <label class="input-group">
                                    <span class="input-group-addon" v-pml-tooltip="'Skype'"><i class="fa-fw fa fa-skype"></i></span>
                                    <input type="text" class="form-control" placeholder="Skype" v-model="record.skype">
                                </label>
                                <span class="error" v-if="errors['skype']">{{ errors['skype'][0] }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['linkedin']}">
                                <label class="input-group">
                                    <span class="input-group-addon" v-pml-tooltip="'LinkedIn'"><i class="fa-fw fa fa-linkedin"></i></span>
                                    <input type="text" class="form-control" placeholder="LinkedIn" v-model="record.linkedin">
                                </label>
                                <span class="error" v-if="errors['linkedin']">{{ errors['linkedin'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['facebook']}">
                                <label class="input-group">
                                    <span class="input-group-addon" v-pml-tooltip="'Facebook'"><i class="fa-fw fa fa-facebook"></i></span>
                                    <input type="text" class="form-control" placeholder="Facebook" v-model="record.facebook">
                                </label>
                                <span class="error" v-if="errors['facebook']">{{ errors['facebook'][0] }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['gplus']}">
                                <label class="input-group">
                                    <span class="input-group-addon" v-pml-tooltip="'Google+'" translate="false"><i class="fa-fw fa fa-google-plus"></i></span>
                                    <input type="text" class="form-control" placeholder="Google" v-model="record.gplus">
                                </label>
                                <span class="error" v-if="errors['gplus']">{{ errors['gplus'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-sm-6 m_bottom_15" :class="{'has-error': errors['instagram']}">
                                <label class="input-group">
                                    <span class="input-group-addon" v-pml-tooltip="'Instagram'"><i class="fa-fw fa fa-instagram"></i></span>
                                    <input type="text" class="form-control" placeholder="Instagram" v-model="record.instagram">
                                </label>
                                <span class="error" v-if="errors['instagram']">{{ errors['instagram'][0] }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-xs-12 col-sm-6 m_md_bottom_15" :class="{'has-error': errors['name']}">
                                <label class="input-group">
                                    <span class="input-group-addon" v-pml-tooltip="'Twitter'"><i class="fa-fw fa fa-twitter"></i></span>
                                    <input type="text" class="form-control" placeholder="Twitter" v-model="record.twitter">
                                </label>
                                <span class="error" v-if="errors['twitter']">{{ errors['twitter'][0] }}</span>
                            </div>
                            <div class="col-xs-12 col-sm-6" :class="{'has-error': errors['pinterest']}">
                                <label class="input-group">
                                    <span class="input-group-addon" v-pml-tooltip="'Pinterest'"><i class="fa-fw fa fa-pinterest"></i></span>
                                    <input type="text" class="form-control" placeholder="Pinterest" v-model="record.pinterest">
                                </label>
                                <span class="error" v-if="errors['pinterest']">{{ errors['pinterest'][0] }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-15 clearfix">
                    <span class="btn btn-white" @click="goBack()">{{ $t('cancel') }}</span>
                    <button type="submit" class="btn btn-default pull-right" v-pml-block="isSaving">{{ $t('save') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import RoutedModals from 'utils/mixins/routed-modals'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { update } from 'services/leads'
    import { mapGetters } from 'vuex'
    import { cloneDeep, isEmpty } from 'lodash'

    export default {
        name: 'EditLeadProfile',
        mixins: [ RoutedModals ],
        mounted () {
            if (!isEmpty(this.lead))
                this.record = cloneDeep(this.lead)
            else
                window.console.log('get lead by request', this.$route.params.id)
        },
        data () {
            return {
                record: {
                    country_id: null
                },
                errors: [],
                isSaving: false
            }
        },
        computed: {
            ...mapGetters({
                'lead': 'getLeadInfo',
                'genders': 'getGender'
            })
        },
        methods: {
            update () {
                this.isSaving = true

                update(this.record.id, this.record)
                    .then(response => {
                        this.goBack()
                        Notify.success(trans('the_record_has_been_saved'))
                    })
                    .catch(error => {
                        Notify.error(trans('_notifications.error'))
                        this.errors = error.response.data.errors || []
                    })
                    .then(() => { this.isSaving = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/leads/components/show/profile/Edit.vue